/**
 * Continue Watching / progress bridge — keeps legacy socket contract.
 * Isolated from PlaybackEngine; host page owns lifecycle.
 */

import io from "socket.io-client";
import { apiConstants } from "../../components/Constant/constants";

var socket = null;

function getSocket() {
  if (!apiConstants.socketUrl) {
    return null;
  }
  if (!socket) {
    socket = io(apiConstants.socketUrl);
  }
  return socket;
}

/**
 * @param {object} payload
 * @param {string|number} payload.userId
 * @param {string} payload.accessToken
 * @param {string|number} payload.subProfileId
 * @param {string|number} payload.adminVideoId
 * @param {number} payload.duration seconds
 */
export function emitContinueWatching(payload) {
  var s = getSocket();
  if (!s || !payload) return;
  s.emit("save_continue_watching_video", {
    sub_profile_id: payload.subProfileId,
    admin_video_id: payload.adminVideoId,
    id: payload.userId,
    token: payload.accessToken,
    duration: payload.duration || 0,
  });
}

export function disconnectContinueWatching() {
  var s = getSocket();
  if (!s) return;
  try {
    s.emit("disconnect");
  } catch (e) {
    /* ignore */
  }
}

/**
 * Polling helper — call start() after first play; pause() on pause; stop() on unmount.
 */
export function createContinueWatchingSession(getDurationSeconds, meta) {
  var intervalId = null;
  var intervalMs = meta.intervalMs != null ? meta.intervalMs : 3000;

  function clearTimer() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  return {
    start: function () {
      clearTimer();
      intervalId = setInterval(function () {
        var duration =
          typeof getDurationSeconds === "function"
            ? getDurationSeconds()
            : 0;
        emitContinueWatching({
          userId: meta.userId,
          accessToken: meta.accessToken,
          subProfileId: meta.subProfileId,
          adminVideoId: meta.adminVideoId,
          duration: duration,
        });
      }, intervalMs);
    },
    /** Stop polling but keep the socket — used on pause so resume can restart. */
    pause: function () {
      clearTimer();
      this.tickOnce();
    },
    stop: function () {
      clearTimer();
      disconnectContinueWatching();
    },
    tickOnce: function () {
      var duration =
        typeof getDurationSeconds === "function" ? getDurationSeconds() : 0;
      emitContinueWatching({
        userId: meta.userId,
        accessToken: meta.accessToken,
        subProfileId: meta.subProfileId,
        adminVideoId: meta.adminVideoId,
        duration: duration,
      });
    },
  };
}

export default createContinueWatchingSession;
